import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api, { formatError } from "../lib/api";
import { AuthShell } from "./Login";
import { Button } from "../components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState("loading"); // loading | ok | error
  const [msg, setMsg] = useState("");

  useEffect(() => {
    if (!token) {
      setState("error");
      setMsg("Missing verification token.");
      return;
    }
    api
      .get(`/auth/verify-email?token=${encodeURIComponent(token)}`)
      .then(() => setState("ok"))
      .catch((err) => {
        setState("error");
        setMsg(formatError(err.response?.data?.detail) || "Verification failed.");
      });
  }, [token]);

  return (
    <AuthShell title="Email verification" subtitle="Confirming your account">
      <div className="text-center py-4" data-testid="verify-result">
        {state === "loading" && <Loader2 className="w-10 h-10 text-sky-600 animate-spin mx-auto" />}
        {state === "ok" && (
          <>
            <CheckCircle2 className="w-12 h-12 text-emerald-500 mx-auto" />
            <p className="mt-4 text-slate-800 font-medium">Your email has been verified.</p>
          </>
        )}
        {state === "error" && (
          <>
            <XCircle className="w-12 h-12 text-red-500 mx-auto" />
            <p className="mt-4 text-slate-800 font-medium">{msg}</p>
          </>
        )}
        <Link to="/app" className="inline-block mt-6">
          <Button className="bg-slate-900 hover:bg-slate-800" data-testid="verify-continue-btn">Continue to app</Button>
        </Link>
      </div>
    </AuthShell>
  );
}
